import isValidSsoMap from './isValidSsoMap';

export default isValidSsoMap;
